export class FeatureFlagKeys {
    public static EnableWETermsConditionsCheckKey: string = "EnableWETermsConditionsCheckFeatureFlag";
    public static CampaignsSortByCountsKey: string = "CampaignsSortByCountsFeatureFlag";
    public static TRCampaignCreativeSamplesKey: string = 'TRCampaignCreativeSamplesFeatureFlag';
    public static TRDownloadCampaignCreativesKey: string = 'TRDownloadCampaignCreativesFeatureFlag';
    public static TRDownloadOwnersManifestKey: string = 'TRDownloadOwnersManifestFeatureFlag';
    public static enableMasterLevelEsign: string = 'EnableMasterLevelEsignFeatureFlag';
}
